import { render, staticRenderFns } from "./FormElementLongTextInput.vue?vue&type=template&id=2d203192"
import script from "./FormElementLongTextInput.vue?vue&type=script&lang=js"
export * from "./FormElementLongTextInput.vue?vue&type=script&lang=js"
import style0 from "./FormElementLongTextInput.vue?vue&type=style&index=0&id=2d203192&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports